// extracted by mini-css-extract-plugin
module.exports = {"articleContent":"RawHTML_articleContent__CeRcE","media":"RawHTML_media__RAd9_","video":"RawHTML_video__Rmhso"};